import { useState, useEffect } from 'react';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import { useDataUser } from '../../context/dataUserContext';
import Modal from 'react-modal';
Modal.setAppElement('#root'); // Para accesibilidad del modal

const serviceOptions = {
    'Internación': [
        '105 - Cuidado intermedio neonatal',
        '106 - Cuidado intermedio pediátrico',
        '107 - Cuidado intermedio adultos',
        '108 - Cuidado intensivo neonatal',
        '109 - Cuidado intensivo pediátrico',
        '110 - Cuidado intensivo adultos',
        '120 - Cuidado básico neonatal',
        '129 - Hospitalización adultos',
        '130 - Hospitalización pediátrica',
        '131 - Hospitalización en salud mental',
        '132 - Hospitalización parcial',
        '133 - Hospitalización paciente crónico con ventilador',
        '134 - Hospitalización paciente crónico sin ventilador',
        '135 - Hospitalización en consumo de sustancias psicoactivas',
        '138 - Cuidado básico del consumo de sustancias psicoactivas'
    ],
    'Quirúrgicos': [
        '201 - Cirugía de cabeza y cuello',
        '202 - Cirugía cardiovascular',
        '203 - Cirugía general',
        '204 - Cirugía ginecológica',
        '205 - Cirugía maxilofacial',
        '207 - Cirugía ortopédica',
        '208 - Cirugía oftalmológica',
        '209 - Cirugía otorrinolaringología',
        '210 - Cirugía oncológica',
        '211 - Cirugía oral',
        '212 - Cirugía pediátrica',
        '213 - Cirugía plástica y estética',
        '214 - Cirugía vascular y angiológica',
        '215 - Cirugía urológica',
        '217 - Otras cirugías',
        '218 - Cirugía endovascular neurológica',
        '227 - Cirugía oncológica pediátrica',
        '231 - Cirugía de la mano',
        '232 - Cirugía de mama y tumores tejidos blandos',
        '233 - Cirugía dermatológica',
        '234 - Cirugía de torax',
        '235 - Cirugía gastrointestinal',
        '237 - Cirugía plástica oncológica',
        '245 - Neurocirugía'
    ],
    'Consulta externa': [
        '301 - Anestesia',
        '302 - Cardiología',
        '303 - Cirugía cardiovascular',
        '304 - Cirugía genérica',
        '306 - Cirugía pediátrica',
        '308 - Dermatología',
        '309 - Dolor y cuidados paliativos',
        '310 - Endocrinología',
        '311 - Endodoncia',
        '312 - Enfermería',
        '313 - Estomatología',
        '316 - Gastroenterología',
        '317 - Genética',
        '318 - Geriatría',
        '320 - Ginecobstetricia',
        '321 - Hematología',
        '323 - Infectología',
        '324 - Inmunología',
        '325 - Medicina familiar',
        '326 - Medicina física y del deporte',
        '327 - Medicina física y de rehabilitación',
        '328 - Medicina general',
        '329 - Medicina interna',
        '330 - Nefrología',
        '331 - Neumología',
        '332 - Neurología',
        '333 - Nutrición y dietética',
        '334 - Odontología general',
        '335 - Oftalmología',
        '336 - Oncología clínica',
        '337 - Optometría',
        '338 - Ortodoncia',
        '339 - Ortopedia y/o traumatología',
        '340 - Otorrinolaringología',
        '342 - Pediatría',
        '343 - Periodoncia',
        '344 - Psicología',
        '345 - Psiquiatría',
        '346 - Rehabilitación oncología',
        '347 - Rehabilitación oral',
        '348 - Reumatología',
        '354 - Toxicología',
        '355 - Urología',
        '356 - Otras consultas de especialidad'
    ],
    'Apoyo diagnóstico y complementación terapéutica': [
        '706 - Laboratorio clínico',
        '709 - Quimioterapia',
        '711 - Radioterapia',
        '712 - Toma de muestras de laboratorio clínico',
        '714 - Servicio farmacéutico',
        '715 - Medicina nuclear',
        '717 - Laboratorio citologías cervico - uterinas',
        '728 - Terapia ocupacional',
        '729 - Terapia respiratoria',
        '731 - Laboratorio de histotecnología',
        '733 - Hemodiálisis',
        '734 - Diálisis peritoneal',
        '739 - Fisioterapia',
        '740 - Fonoaudiología y/o terapia del lenguaje',
        '742 - Diagnóstico vascular',
        '743 - Hemodinamia e intervencionismo',
        '744 - Imágenes diagnósticas - Ionizantes',
        '745 - Imágenes diagnósticas - No ionizantes',
        '746 - Gestión pre-transfusional',
        '747 - Patología',
        '748 - Radiología odontológica',
        '749 - Toma de muestras de cuello uterino y ginecológicas'
    ],
    'Atención inmediata': [
        '1101 - Atención del parto',
        '1102 - Urgencias',
        '1103 - Transporte asistencial básico',
        '1104 - Transporte asistencial medicalizado',
        '1105 - Atención prehospitalaria'
    ]
};
const ServiceModal = ({ isOpen, onClose, sedes, render }) => {

    const { clinicId } = useDataUser();

    const [newService, setNewService] = useState({
        group: '',
        service: '',
        modality: '',
        telemedicine: '',
        complexity: '',
        habilitationNumber: '',
        habilitationDocument: '',
        consultationValue: '',
        copayValue: '',
        netValue: '',
        sede: ''
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewService({
            ...newService,
            [name]: value
        });
    };

    useEffect(() => {
        const consultationValue = parseFloat(newService.consultationValue) || 0;
        const copayValue = parseFloat(newService.copayValue) || 0;
        setNewService({
            ...newService,
            netValue: consultationValue + copayValue
        });
    }, [newService.consultationValue, newService.copayValue]);



    const handleSave = async () => {
        try {
            const serviceData = {
                group: newService.group,
                service: newService.service,
                modality: newService.modality,
                telemedicine: newService.telemedicine,
                complexity: newService.complexity,
                habilitationNumber: newService.habilitationNumber,
                consultationValue: newService.consultationValue,
                copayValue: newService.copayValue,
                netValue: newService.netValue,
                sedeCode: newService.sede,
                sede_clinica_documento_habilitacion: newService.habilitationDocument,
                sedeName: sedes.find(sede => sede.code === newService.sede)?.name || '',
                clinicInfo: clinicId
            };

            const dataServiceToSend = new FormData();

            for (const key in serviceData) {
                console.log(key, serviceData[key]);
                dataServiceToSend.append(key, serviceData[key]);
            }


            await apiClient.post(`/api/clinic/createService`, dataServiceToSend);

            alertaGeneral({
                titulo: "¡Servicio Creado con éxito!",
            });
            onClose();
            render()
            setNewService('');

            // Cerrar modal al guardar

        } catch (error) {
            console.error('Error al crear el servicio:', error);
            alertaGeneral({
                titulo: "¡Error al crear el servicio!",
                isError: true
            });
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="w-[60%] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[10]"
        >
            <h2 className="text-2xl text-left text-[#205087ff] font-bold mb-4">Agregar servicio</h2>
            <div className="text-left grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Select para sede */}
                <div className="form-group">
                    <label className="form-label">Sede</label>
                    <select
                        name="sede"
                        value={newService.sede}
                        onChange={handleChange}
                        className="form-input"
                        required
                    >
                        <option value="">Selecciona Sede</option>
                        {sedes.map((sede, index) => (
                            <option key={index} value={sede.code}>{sede.name}</option>
                        ))}
                    </select>
                    {errors.sede && <p className="text-red-500 text-sm">{errors.sede}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Grupo</label>
                    <select
                        name="group"
                        value={newService.group}
                        onChange={handleChange}
                        className="form-input"
                        required
                    >
                        <option value="">Selecciona Grupo</option>
                        {Object.keys(serviceOptions).map((group, index) => (
                            <option key={index} value={group}>{group}</option>
                        ))}
                    </select>
                    {errors.group && <p className="text-red-500 text-sm">{errors.group}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Servicio</label>
                    <select
                        name="service"
                        value={newService.service}
                        onChange={handleChange}
                        className="form-input"
                        required
                    >
                        <option value="">Selecciona Servicio</option>
                        {newService.group && serviceOptions[newService.group].map((service, index) => (
                            <option key={index} value={service}>{service}</option>
                        ))}
                    </select>
                    {errors.service && <p className="text-red-500 text-sm">{errors.service}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Modalidad</label>
                    <select
                        name="modality"
                        value={newService.modality}
                        onChange={handleChange}
                        className="form-input"
                        required
                    >
                        <option value="">Selecciona Modalidad</option>
                        <option value="Intramural">Intramural</option>
                        <option value="Extramural">Extramural</option>
                        <option value="Telemedicina">Telemedicina</option>
                    </select>
                    {errors.modality && <p className="text-red-500 text-sm">{errors.modality}</p>}
                </div>
                {newService.modality === "Telemedicina" && (
                    <div className="form-group">
                        <label className="form-label">Telemedicina</label>
                        <select
                            name="telemedicine"
                            value={newService.telemedicine}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona Telemedicina</option>
                            <option value="Prestador de referencia">Prestador de referencia</option>
                            <option value="Prestador remisor">Prestador remisor</option>
                        </select>
                        {errors.telemedicine && <p className="text-red-500 text-sm">{errors.telemedicine}</p>}
                    </div>
                )}
                <div className="form-group">
                    <label className="form-label">Complejidad</label>
                    <select
                        name="complexity"
                        value={newService.complexity}
                        onChange={handleChange}
                        className="form-input"
                        required
                    >
                        <option value="">Selecciona Complejidad</option>
                        <option value="Baja">Baja</option>
                        <option value="Media">Media</option>
                        <option value="Alta">Alta</option>
                    </select>
                    {errors.complexity && <p className="text-red-500 text-sm">{errors.complexity}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Número de habilitación</label>
                    <input
                        type="text"
                        name="habilitationNumber"
                        value={newService.habilitationNumber}
                        onChange={handleChange}
                        className="form-input"
                        required
                    />
                    {errors.habilitationNumber && <p className="text-red-500 text-sm">{errors.habilitationNumber}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Documento habilitación</label>
                    <input
                        type="file"
                        name="sede_clinica_documento_habilitacion"
                        onChange={(e) => setNewService({ ...newService, habilitationDocument: e.target.files[0] })}
                        className="form-input"
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">Valor de la consulta</label>
                    <input
                        type="number"
                        name="consultationValue"
                        value={newService.consultationValue}
                        onChange={handleChange}
                        placeholder="Ej. 50.000"
                        className={`form-input ${errors.consultationValue && "border-red-500"}`}
                        required
                    />
                    {errors.consultationValue && <p className="text-red-500 text-sm">{errors.consultationValue}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Valor de la cuota moderadora</label>
                    <input
                        type="number"
                        name="copayValue"
                        value={newService.copayValue}
                        onChange={handleChange}
                        placeholder="Ej. 10.000"
                        className={`form-input ${errors.copayValue && "border-red-500"}`}
                        required
                    />
                    {errors.copayValue && <p className="text-red-500 text-sm">{errors.copayValue}</p>}
                </div>
                <div className="form-group">
                    <label className="form-label">Valor neto a pagar</label>
                    <input
                        type="number"
                        name="netValue"
                        value={newService.netValue}
                        readOnly
                        className="form-input bg-gray-100"
                    />
                    {errors.netValue && <p className="text-red-500 text-sm">{errors.netValue}</p>}
                </div>
            </div>
            <div className="flex justify-end mt-4 gap-3">
                <button onClick={onClose} className="button-gray">Cancelar</button>
                <button onClick={handleSave} className="button-send">Guardar</button>
            </div>
        </Modal>
    );
};

export default ServiceModal;
